import { ApiResponse } from "interfaces/models/api";
import { BlackboardFrame } from "interfaces/models/blackboard";
import { axiosECS } from "services/baseAxios";

const path = `/v1/blackboards/frames`;

export const getBlackboardFrameList = async (
  blackboardFormatId: string,
  shouldCache?: boolean
): Promise<ApiResponse<BlackboardFrame[]>> => {
  return axiosECS.get(path, {
    params: { blackboardFormatId, shouldCache },
  });
};

export const bulkCreateBlackboardFrames = async (body: {
  blackboardFormatId: string;
  frames: BlackboardFrame[];
}) => {
  return axiosECS.post(`${path}/bulk`, body);
};
